import { formatAmount, formatSortCode } from "@utils";

const RefundSummaryRows = ({
  amount,
  accountHolderName,
  reference,
  accountNumber,
  sortCode,
}) => (
  <>
    <div className="flex border-b border-zinc-200 text-sm py-3">
      <span className="text-zinc-500 w-2/3">Amount</span>
      <span className="font-medium">{formatAmount(amount)}</span>
    </div>
    <div className="flex border-b border-zinc-200 py-3 text-sm">
      <span className="text-zinc-500 w-2/3">Payee</span>
      <span className="font-medium">{accountHolderName}</span>
    </div>
    <div className="flex border-b border-zinc-200 py-3 text-sm">
      <span className="text-zinc-500 w-2/3">Reference</span>
      <span className="font-medium">{reference}</span>
    </div>
    {accountNumber && (
      <div className="flex border-b border-zinc-200 py-3 text-sm">
        <span className="text-zinc-500 w-2/3">Account number</span>
        <span className="font-medium">{accountNumber}</span>
      </div>
    )}
    {sortCode && (
      <div className="flex py-3 text-sm">
        <span className="text-zinc-500 w-2/3">Sort code</span>
        <span className="font-medium">{formatSortCode(sortCode)}</span>
      </div>
    )}
  </>
);

export default RefundSummaryRows;
